export default {
  categories: [],
}